import {app} from '../app'
import {Habitat} from './habitat'

let costdesirelevel = 22
let costcurrentlevel = 1

let desirelevel = 22
let currentlevel = 1
let steps = 20000
let habs = false

let levelup-tab = 'left'

export tag Level
	def render
		<self>
			<.block[g:0]>
				<.harvest-tabs>
					<h2 .active=(levelup-tab == 'left') @click=(do levelup-tab = 'left')> app.trans.tab21[app.lg]
					<h2 .active=(levelup-tab == 'right') @click=(do levelup-tab = 'right')> app.trans.tab22[app.lg]
				if levelup-tab == 'left'
					<form>
						<label> app.trans.in-st[app.lg]
							<input placeholder="Enter value" bind=steps>
						<label> app.trans.in-curle[app.lg]
							<.plus-minus>
								<.mns-btn @click=(do currentlevel--)>
								<input type="number" inputmode="numeric" placeholder="Enter value" bind=currentlevel>
								<.pls-btn @click=(do currentlevel++)>
						<label> app.trans.in-tarle[app.lg]
							<.plus-minus>
								<.mns-btn @click=(do desirelevel--)>
								<input type="number" inputmode="numeric" placeholder="Enter value" bind=desirelevel>
								<.pls-btn @click=(do desirelevel++)>
					<label.sw @click=(habs = !habs)> app.trans.switch[app.lg]
						<.switch .active=(habs == true)>
					if habs
						<.hab-list>
							<Habitat name=(app.trans.sub-hab[app.lg] + ' 2') id=8>
							<Habitat name=(app.trans.sub-hab[app.lg] + ' 1') id=7>
							<Habitat name=(app.trans.gen-hab[app.lg]) id=6>
				if levelup-tab == 'right'
					<form>
						<label> app.trans.in-curle[app.lg]
							<.plus-minus>
								<.mns-btn @click=(do costcurrentlevel--)>
								<input type="number" inputmode="numeric" placeholder="Enter value" bind=costcurrentlevel>
								<.pls-btn @click=(do costcurrentlevel == (costdesirelevel - 1) ? costcurrentlevel++ && costdesirelevel++ : costcurrentlevel++)>
						<label> app.trans.in-tarle[app.lg]
							<.plus-minus>
								<.mns-btn @click=(do costdesirelevel--)>
								<input type="number" inputmode="numeric" placeholder="Enter value" bind=costdesirelevel>
								<.pls-btn @click=(do costdesirelevel++)>
						<label[h:0 m:0 lh:0]>
			<.block.results>
				if levelup-tab == 'left'
					<.results-data>
						<.cap>
							<h1 .notranslate> app.SpaceNum((app.cumulativeXP[desirelevel - 1] - app.cumulativeXP[currentlevel - 1]))
							<p> app.trans.en-need[app.lg]
						<.cap>
							<h1 .notranslate > app.SpaceNum(app.LevelDays(currentlevel, desirelevel, steps))
							<p> app.trans.days-noki[app.lg]
						if habs == true
							<.cap>
								<h1 .notranslate .none=(typeof app.LevelDays(currentlevel, desirelevel, steps, 0.02) == 'string')> app.SpaceNum(app.LevelDays(currentlevel, desirelevel, steps, 0.02))
								<p> app.trans.days14[app.lg]
							<.cap>
								<h1 .notranslate .none=(typeof app.LevelDays(currentlevel, desirelevel, steps, 0.0143) == 'string')> app.SpaceNum(app.LevelDays(currentlevel, desirelevel, steps, 0.0143))
								<p> app.trans.days10[app.lg]
							<.cap>
								<h1 .notranslate .none=(typeof app.LevelDays(currentlevel, desirelevel, steps, 0.0095) == 'string')> app.SpaceNum(app.LevelDays(currentlevel, desirelevel, steps, 0.0095))
								<p> app.trans.days7[app.lg]
				if levelup-tab == 'right'
					<.results-data>
						<.cap>
							<h1 .notranslate> app.SpaceNum((app.cumulativeXP[costdesirelevel - 1] - app.cumulativeXP[costcurrentlevel - 1]))
							<p> app.trans.en-need[app.lg]
						<.cap>
							<h1 .notranslate> app.SpaceNum(((app.cumulativeXP[costdesirelevel - 1] - app.cumulativeXP[costcurrentlevel - 1]) * 0.022).toFixed(2))
							<p> 'KI'
						<.cap>
							<h1 .notranslate> app.SpaceNum(((app.cumulativeXP[costdesirelevel - 1] - app.cumulativeXP[costcurrentlevel - 1]) * 0.022 * app.rates.ki).toFixed(2))
							<p> 'USD'